import styled from "styled-components";

const PagerHeader = styled.div`
  padding-bottom: 20px;
  font-size: 16px;
  display: block;
  text-align: center;
  line-height: 1.4;
  color: #757575;
`;
export default PagerHeader;
